"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const login2FAAction_1 = require("@/features/login2fa/actions/login2FAAction");
const transaction_signing_store_1 = require("@/store/transaction-signing-store");
const stitcherLogin2FATrigger = (props) => {
    console.log('stitcher ---> stitcherLogin2FATrigger:', props);
    // const dispatch = useDispatch();
    transaction_signing_store_1.store.dispatch((0, login2FAAction_1.prepareStart2FAWorkFlowData)(props));
    transaction_signing_store_1.store.dispatch((0, login2FAAction_1.start2FAWorkFlow)());
};
exports.default = { stitcherLogin2FATrigger };
